// extracted by mini-css-extract-plugin
module.exports = {"container":"services_container__1P18r"};